import { Stack } from "@mui/material";
import { type GetPensionTransactionsResponse } from "@repo/api";
import { type FC } from "react";
import { TransactionSkeleton } from "../../Transactions/SingleTransactionRow";
import TransactionsContainer from "../../Transactions/TransactionsContainer";

type TransactionsListProps = {
	data: GetPensionTransactionsResponse[];
	isLoading: boolean;
	fetching: string;
	skeletonsCount: number;
};

interface TransactionsListSkeletonProps {
	skeletonsCount: number;
}

export const TransactionsListSkeleton: FC<TransactionsListSkeletonProps> = ({
	skeletonsCount,
}) => {
	return (
		<Stack spacing={4} py={3}>
			{[...Array(skeletonsCount).keys()].map((_, index) => (
				<TransactionSkeleton key={index} />
			))}
		</Stack>
	);
}

const TransactionsList: FC<TransactionsListProps> = ({
	fetching,
	isLoading,
	data,
	skeletonsCount = 6,
}) => {
	return (
		<>
			{!isLoading && (
				<TransactionsContainer isIcon={true} transactions={data} />
			)}
			{fetching === "fetching" && (
				<TransactionsListSkeleton skeletonsCount={skeletonsCount} />
			)}
		</>
	);
};

export default TransactionsList;
